import * as React from "react";
import {RouteComponentProps, Redirect} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {indexPath, routePaths} from "egold/routes";
import Timer from "egold/components/timer";
import {IBuyPrice, IEgoldUserDetails, IVerifyGoldPrice} from "StateInterface";
import {useEffect, useRef} from "react";
import {clearPaymentLink, clearVerifyPrice, getPaymentLink, showToast} from "egold/actions";
import {vendor} from "egold/egold-config";
import {insideHeader, removeCountryCode, ToastBgColor} from "egold/utils";
import {getIdToken} from "service.tsx";
import {
    notifyAndroid,
    setAndroidTokenAndVersionBeforeRedirecting,
} from "utils/android";
import {EVENT_NAMES} from "Dashboard/utils";
interface IConnectProps {
    dispatch?: (action: any) => void;
    buyPrice: IBuyPrice;
    verifyBuyPrice: IVerifyGoldPrice;
    eGoldUserDetails: IEgoldUserDetails;
    paymentLink: string;
    apiVersion: number;
    isAndroid: boolean;
    userId: number;
    isError: boolean;
}
function BuyGoldConfirm(props: IConnectProps & RouteComponentProps) {
    const timerRef: any = useRef();
    useEffect(() => {
        if (props.isAndroid) {
            notifyAndroid("TOOL_BAR_CONFIG", {visibility: false});
        }
    }, []);
    useEffect(() => {
    if (props.paymentLink) {
        if (props.isAndroid) {
            setAndroidTokenAndVersionBeforeRedirecting(props.apiVersion, getIdToken());
        }
        window.location.replace(props.paymentLink);
    }
    return () => componentUnmount();
    }, [props.paymentLink]);

    function componentUnmount() {
        if (props.isAndroid) {
            notifyAndroid("TOOL_BAR_CONFIG", {visibility: true, title: "Payment"});
        }
        props.dispatch(clearPaymentLink());
        props.dispatch(clearVerifyPrice());
    }
    const handleProceed = () => {
        const paymentDetails = {
            mobile: removeCountryCode(String(props.eGoldUserDetails.mobile)),
            email: props.eGoldUserDetails.email,
            amount: Number(props.verifyBuyPrice.buy_price),
            user_id: String(props.userId),
            txn_id: String(props.verifyBuyPrice.txn_id),
            vendor_id: String(props.eGoldUserDetails.vendor_id),
            txn_type: "BUY",
            vendor: vendor.SAFEGOLD,
            name: "Buy Gold User",
            ...(props.isAndroid) ? {platform: "android"} : {platform: "web"},   
        };
        props.dispatch(getPaymentLink(paymentDetails));
    };
    function renderProceed() {
        return(
            <button className="mt-4 mb-2 eGold-submit-btn" onClick = {() => handleProceed()}>
                Make Payment
            </button>
        );
    }
    if (!props.location.state && !props.verifyBuyPrice) {
       return <Redirect to={`${indexPath}${routePaths.BUY_GOLD}`}/>;
    }
    function restartTimer(time) {
        props.dispatch(showToast(ToastBgColor.WARNING, "Gold price may change"));
        timerRef.current.reStartTimer(time);
    }
    const {timer} = props.location.state;
    if (props.isError) {
        return <Redirect to={`${indexPath}${routePaths.BUY_GOLD}`}/>;
    }
    return (
        <div className="confirm-container mx-2">
            {
                props.verifyBuyPrice ?
                    <div>
                        {insideHeader("Confirm Payment", props.history.goBack)}
                        <div className="text-center">
                            <span className="d-block mt-1 small-text">
                            Gold Rate valid for <Timer seconds={300}
                                               ref={timerRef}
                                               handleTimeEnd={() => restartTimer(300)}
                            />
                        </span>
                        </div>
                        {renderDetails(props.buyPrice.current_price, props.verifyBuyPrice)}
                        {renderProceed()}
                    </div> : <div className="border p-5">Sorry. Please try again !</div>
            }
        </div>
    );
}

function renderDetails(currentPrice: number, verifyPrice: IVerifyGoldPrice) {
    return(
        <div className="table-border p-2 mt-4">
            <table className="table table-borderless table-sm" style={{fontSize: "14px"}}>
                <tbody>
                <tr>
                    <td>Gold Rate</td>
                    <td className="text-right">
                        <i className="fa fa-inr price-icon-small" aria-hidden="true"/>&nbsp;
                        {currentPrice}/gm</td>
                </tr>
                <tr>
                    <td>Quantity</td>
                    <td className="text-right">{`${verifyPrice.gold_amount}gm(s)`}</td>
                </tr>
                <tr>
                    <td>Purity</td>
                    <td className="text-right">99.5%</td>
                </tr>
                <tr>
                    <td>Date</td>
                    <td className="text-right">{new Date().toDateString()}</td>
                </tr>
                <tr>
                    <td>GST Amount</td>
                    <td className="text-right">
                        <i className="fa fa-inr price-icon-small" aria-hidden="true"/>&nbsp;
                        {verifyPrice.gst_amount}
                    </td>
                </tr>
                <tr className="pt-3 border-top">
                    <th>Total Payable Amount</th>
                    <th className="text-right">
                        <i className="fa fa-inr price-icon-small" aria-hidden="true"/>&nbsp;
                        {verifyPrice.buy_price}
                    </th>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        buyPrice: state.eGold.buyPrice,
        verifyBuyPrice: state.eGold.verifyBuyPrice,
        eGoldUserDetails: state.eGold.eGoldUserDetails,
        paymentLink: state.eGold.paymentLink,
        apiVersion: state.login.apiVersion,
        isAndroid: state.login.isAndroid,
        userId: state.login.auth.userId,
        isError: state.eGold.isError,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(BuyGoldConfirm);
